import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_electric-essentials/artifacts/qwfv0qsr_Derby%20logo.png";

export const Footer = () => (
  <footer className="bg-black border-t border-gray-800 py-8 px-4" data-testid="site-footer">
    <div className="container mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="flex items-center space-x-2 mb-4 md:mb-0">
          <img
            src={LOGO_URL}
            alt="Derby Logo"
            className="h-10 w-auto"
          />
        </div>
        <p className="text-gray-400 text-sm">
          © 2025 Derby Wires. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
